import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 引入iview组件
import iView from 'iview';
import 'iview/dist/styles/iview.css';

// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)

// 引入VueUeditorWrap组件
// import VueUeditorWrap from 'vue-ueditor-wrap'

// 引入百度ueidtor
// import '../public/UE/ueditor.config.js';
// import '../public/UE/ueditor.all.min.js';
// import '../public/UE/lang/zh-cn/zh-cn.js';
// import '../public/UE/ueditor.parse.min.js';
// import './assets/UE/ueditor.config.js';
// import './assets/UE/ueditor.all.min.js';
// import './assets/UE/lang/zh-cn/zh-cn.js';
// import './assets/UE/ueditor.parse.min.js';

// 引入图表组件 echarts(全局引入代价太大，还是在单独页面按需引入较好)
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.use(iView);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  // components: { App },
  render: h => h(App),
}).$mount('#app');
